// extracted by mini-css-extract-plugin
export default {"wrapper":"RemoteJob_wrapper__8738S","remoteForm":"RemoteJob_remoteForm__JjXWQ","btn":"RemoteJob_btn__uozgQ"};